import React, {CSSProperties} from 'react';

import {useRulesForPassword} from '@src/hooks/useRulesForPassword';

import * as S from './PasswordRules.styles';

const PASSWORD_MINIMUM_ACCEPTED_CHARACTERS = 8;

export interface PasswordRulesProps {
  password: string;
  backgroundColor?: CSSProperties['color'];
  isBoxShadow?: boolean;
}

const PasswordRules = ({password, backgroundColor, isBoxShadow = false, ...props}: PasswordRulesProps) => {
  const {passwordHasEnoughCharacters, passwordHasSpecialCharacter, passwordHasNumber} = useRulesForPassword(password);
  return (
    <S.Wrapper backgroundColor={backgroundColor} isBoxShadow={isBoxShadow} {...props}>
      <S.Title>Rules for Passwords</S.Title>
      <S.Text>To create a new password, you have to meet all the following requirements:</S.Text>

      <S.List>
        <S.ListItem isValid={passwordHasEnoughCharacters}>
          {passwordHasEnoughCharacters && <S.GreenCheckMarkIcon />}
          <S.Text>Minimum {PASSWORD_MINIMUM_ACCEPTED_CHARACTERS} characters</S.Text>
        </S.ListItem>
        <S.ListItem isValid={passwordHasSpecialCharacter}>
          {passwordHasSpecialCharacter && <S.GreenCheckMarkIcon />}
          <S.Text>At least one special character (@, &amp;, etc)</S.Text>
        </S.ListItem>
        <S.ListItem isValid={passwordHasNumber}>
          {passwordHasNumber && <S.GreenCheckMarkIcon />}
          <S.Text>At least one number</S.Text>
        </S.ListItem>
      </S.List>
    </S.Wrapper>
  );
};

export default PasswordRules;
